module.exports = __webpack_public_path__ + "img/manet_4.9d108d27.jpg";